import React from 'react';
import './RecentTransactions.css';

const RecentTransactions: React.FC = () => {
  const transactions = [
    { propertyType: 'Single Family Home', location: 'Beverly Hills, CA', loanAmount: '$2,400,000', term: '30 Yrs fixed' },
    { propertyType: 'Single Family Home', location: 'Rolling Hills Estates, CA', loanAmount: '$1,500,000', term: '30 Yrs fixed' },
    { propertyType: 'Single Family Home', location: 'Palos Verdes, CA', loanAmount: '$2,100,000', term: '30 Yrs fixed' },
    { propertyType: 'Single Family Home', location: 'Beverly Hills, CA', loanAmount: '$1,500,000', term: '30 Yrs fixed' },
    { propertyType: 'Single Family Home', location: 'Rolling Hills Estates, CA', loanAmount: '$2,400,000', term: '12 months' },
    { propertyType: 'Single Family Home', location: 'Manhattan Beach, CA', loanAmount: '$600,000', term: '30 Yrs fixed' }
  ];

  return (
    <section className="recent-transactions-section">
      <div className="recent-transactions-container">
        <div className="recent-transactions-header">
          <h2 className="recent-transactions-title">Recent transactions</h2>
          <p className="recent-transactions-subtitle">
            Stay up-to-date with the latest mortgage rates available today. Our competitive rates ensure you get the best deal, whether you're buying a home or refinancing an existing mortgage. Check current rates and see how we can help you secure the ideal mortgage for your needs.
          </p>
        </div>
        <div className="transactions-list">
          {transactions.map((transaction, index) => (
            <div key={index} className="transaction-item">
              <div className="transaction-details-group">
                <div className="transaction-detail">
                  <span className="detail-label">Property type</span>
                  <span className="detail-value property-type">{transaction.propertyType}</span>
                </div>
                <div className="transaction-detail">
                  <span className="detail-label">Location</span>
                  <span className="detail-value location-value">{transaction.location}</span>
                </div>
              </div>
              <div className="transaction-details-group">
                <div className="transaction-detail">
                  <span className="detail-label">Loan amount</span>
                  <span className="detail-value loan-amount">{transaction.loanAmount}</span>
                </div>
                <div className="transaction-detail">
                  <span className="detail-label">Term</span>
                  <span className="detail-value term-value">{transaction.term}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RecentTransactions;
